import { Component, Input, OnInit, OnChanges  } from '@angular/core';

@Component({
    selector: 'app-lot-stats',
    templateUrl: './lot-stats.component.html',
    styleUrls: ['./lot-stats.component.css']
})
export class LotStatsComponent implements OnInit, OnChanges {

    @Input()
    verification: string[];

    @Input()
    verificationStats: any[];

    public barChartLabels: string[];
    public barChartData: any[];


    constructor() { }

    ngOnInit() {
        // Get the labels for the var chart.
        this.barChartLabels = this.verification;
        this.getChartValues();
    }


    public barChartOptions: any = {
        // scaleShowVerticalLines: false,
        scaleShowGridLines: false,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'bottom'
        },
        scales: {
            xAxes: [{
                gridLines: {
                    display: false
                }
            }
            ],
            yAxes: [{
                gridLines: {
                    display: false
                }
            }
            ]
        }
    };

    public barChartType: string = 'bar';
    public barChartLegend: boolean = true;
    public barChartColors: Array<any> = [
        { // warning
            backgroundColor: '#ffe872',
            borderColor: '#faebcc',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
            backgroundColor: 'white',
            borderColor: 'white',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
        { // verified
            backgroundColor: '#abe892',
            borderColor: ' #d6e9c6',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // discrepancy
            backgroundColor: '#f1b7b7',
            borderColor: '#ebccd1',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];


    // events
    public chartClicked(e: any): void {

    }

    public chartHovered(e: any): void {

    }


    /**
     *  Get the values of chart grouped by the status type
     */
    getChartValues() {
        this.barChartData
            = [
            {data: this.verificationStats['under_process'], label: 'Under Process'},
            {data: this.verificationStats['not_initiated'], label: 'Not Initiated'},
            {data: this.verificationStats['verified'], label: 'Verified'},
            {data: this.verificationStats['discrepancy'], label: 'Discrepancy'}
        ];
    }

    ngOnChanges() {
      this.ngOnInit();
    }
}





// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/lot/lot-stats/lot-stats.component.ts